<nav class="navbar navbar-expand-lg" [ngClass]="ies.path">
  <div class="container">
    <div class="row">
      <div class="navbar-brand">
        <a routerLink=""><img [src]="logo" alt="Logo {{ies.name}}"></a>
      </div>
    </div>
  </div>
</nav>
